export const communityRoadmaps = [
  {
    id: 'fullstack_web_dev',
    title: 'Full Stack Web Development',
    topic: 'Web Development',
    category: 'programming',
    icon: '💻',
    description: 'Complete path to becoming a full stack developer with React, Node.js, and MongoDB',
    duration_weeks: 16,
    confidence: 0.95,
    why_this_fits: 'Comprehensive curriculum covering frontend, backend, databases, and deployment',
    weeks: [
      {
        week: 1,
        theme: 'HTML & CSS Fundamentals',
        tasks: [{
          id: '1',
          title: 'Master HTML5',
          description: 'Learn semantic HTML, forms, and accessibility',
          est_hours: 10,
          deliverable: 'Build a portfolio website',
          resources: [
            { title: 'HTML Full Course', url: 'https://www.youtube.com/watch?v=pQN-pnXPaVg', type: 'video', platform: 'YouTube', is_free: true, duration: '2h' },
            { title: 'MDN HTML Guide', url: 'https://developer.mozilla.org/en-US/docs/Learn/HTML', type: 'doc', platform: 'MDN', is_free: true }
          ]
        }]
      },
      {
        week: 2,
        theme: 'Advanced CSS & Flexbox',
        tasks: [{
          id: '2',
          title: 'CSS Grid & Flexbox',
          description: 'Master modern CSS layouts',
          est_hours: 12,
          deliverable: 'Responsive landing page',
          resources: [
            { title: 'CSS Complete Guide', url: 'https://www.youtube.com/watch?v=1Rs2ND1ryYc', type: 'video', platform: 'YouTube', is_free: true, duration: '6h' }
          ]
        }]
      },
      {
        week: 3,
        theme: 'JavaScript Basics',
        tasks: [{
          id: '3',
          title: 'JavaScript Fundamentals',
          description: 'Variables, functions, arrays, objects',
          est_hours: 15,
          deliverable: 'Interactive calculator app',
          resources: [
            { title: 'JavaScript Tutorial', url: 'https://www.youtube.com/watch?v=PkZNo7MFNFg', type: 'video', platform: 'YouTube', is_free: true, duration: '3h' }
          ]
        }]
      },
      {
        week: 4,
        theme: 'DOM Manipulation',
        tasks: [{
          id: '4',
          title: 'DOM & Events',
          description: 'Manipulate HTML with JavaScript',
          est_hours: 12,
          deliverable: 'Todo list application',
          resources: [
            { title: 'DOM Manipulation', url: 'https://www.youtube.com/watch?v=5fb2aPlgoys', type: 'video', platform: 'YouTube', is_free: true, duration: '4h' }
          ]
        }]
      },
      {
        week: 5,
        theme: 'ES6+ Features',
        tasks: [{
          id: '5',
          title: 'Modern JavaScript',
          description: 'Arrow functions, destructuring, modules',
          est_hours: 10,
          deliverable: 'Refactor previous projects',
          resources: [
            { title: 'ES6 Tutorial', url: 'https://www.youtube.com/watch?v=nZ1DMMsyVyI', type: 'video', platform: 'YouTube', is_free: true, duration: '1h' }
          ]
        }]
      },
      {
        week: 6,
        theme: 'React Fundamentals',
        tasks: [{
          id: '6',
          title: 'React Components & Props',
          description: 'Learn component-based architecture',
          est_hours: 15,
          deliverable: 'React weather app',
          resources: [
            { title: 'React Course', url: 'https://www.youtube.com/watch?v=bMknfKXIFA8', type: 'video', platform: 'YouTube', is_free: true, duration: '12h' }
          ]
        }]
      },
      {
        week: 7,
        theme: 'React Hooks & State',
        tasks: [{
          id: '7',
          title: 'useState & useEffect',
          description: 'Master React hooks',
          est_hours: 12,
          deliverable: 'Shopping cart app',
          resources: [
            { title: 'React Hooks', url: 'https://www.youtube.com/watch?v=O6P86uwfdR0', type: 'video', platform: 'YouTube', is_free: true, duration: '1h' }
          ]
        }]
      },
      {
        week: 8,
        theme: 'Node.js Basics',
        tasks: [{
          id: '8',
          title: 'Node.js & NPM',
          description: 'Backend JavaScript fundamentals',
          est_hours: 12,
          deliverable: 'Simple HTTP server',
          resources: [
            { title: 'Node.js Tutorial', url: 'https://www.youtube.com/watch?v=TlB_eWDSMt4', type: 'video', platform: 'YouTube', is_free: true, duration: '3h' }
          ]
        }]
      },
      {
        week: 9,
        theme: 'Express.js Framework',
        tasks: [{
          id: '9',
          title: 'REST API with Express',
          description: 'Build RESTful APIs',
          est_hours: 15,
          deliverable: 'Blog API',
          resources: [
            { title: 'Express.js Course', url: 'https://www.youtube.com/watch?v=Oe421EPjeBE', type: 'video', platform: 'YouTube', is_free: true, duration: '8h' }
          ]
        }]
      },
      {
        week: 10,
        theme: 'MongoDB & Mongoose',
        tasks: [{
          id: '10',
          title: 'NoSQL Database',
          description: 'Database design and queries',
          est_hours: 12,
          deliverable: 'User management system',
          resources: [
            { title: 'MongoDB Tutorial', url: 'https://www.youtube.com/watch?v=c2M-rlkkT5o', type: 'video', platform: 'YouTube', is_free: true, duration: '1h' }
          ]
        }]
      },
      {
        week: 11,
        theme: 'Authentication & Security',
        tasks: [{
          id: '11',
          title: 'JWT & bcrypt',
          description: 'Implement user authentication',
          est_hours: 15,
          deliverable: 'Auth system',
          resources: [
            { title: 'JWT Authentication', url: 'https://www.youtube.com/watch?v=mbsmsi7l3r4', type: 'video', platform: 'YouTube', is_free: true, duration: '1h' }
          ]
        }]
      },
      {
        week: 12,
        theme: 'Full Stack Integration',
        tasks: [{
          id: '12',
          title: 'Connect Frontend & Backend',
          description: 'CORS, API calls, state management',
          est_hours: 15,
          deliverable: 'Full stack app',
          resources: [
            { title: 'MERN Stack', url: 'https://www.youtube.com/watch?v=7CqJlxBYj-M', type: 'video', platform: 'YouTube', is_free: true, duration: '5h' }
          ]
        }]
      },
      {
        week: 13,
        theme: 'Testing',
        tasks: [{
          id: '13',
          title: 'Jest & React Testing Library',
          description: 'Write unit and integration tests',
          est_hours: 10,
          deliverable: 'Test suite',
          resources: [
            { title: 'Testing Tutorial', url: 'https://www.youtube.com/watch?v=8Xwq35cPwYg', type: 'video', platform: 'YouTube', is_free: true, duration: '1h' }
          ]
        }]
      },
      {
        week: 14,
        theme: 'Deployment',
        tasks: [{
          id: '14',
          title: 'Deploy to Vercel & Render',
          description: 'Production deployment',
          est_hours: 8,
          deliverable: 'Live application',
          resources: [
            { title: 'Deployment Guide', url: 'https://www.youtube.com/watch?v=l134cBAJCuc', type: 'video', platform: 'YouTube', is_free: true, duration: '30m' }
          ]
        }]
      },
      {
        week: 15,
        theme: 'Advanced Topics',
        tasks: [{
          id: '15',
          title: 'WebSockets & Real-time',
          description: 'Socket.io implementation',
          est_hours: 12,
          deliverable: 'Chat application',
          resources: [
            { title: 'Socket.io Tutorial', url: 'https://www.youtube.com/watch?v=1BfCnjr_Vjg', type: 'video', platform: 'YouTube', is_free: true, duration: '1h' }
          ]
        }]
      },
      {
        week: 16,
        theme: 'Final Project',
        tasks: [{
          id: '16',
          title: 'Capstone Project',
          description: 'Build a complete application',
          est_hours: 20,
          deliverable: 'Portfolio project',
          resources: [
            { title: 'Project Ideas', url: 'https://github.com/florinpop17/app-ideas', type: 'doc', platform: 'GitHub', is_free: true }
          ]
        }]
      }
    ]
  },
  {
    id: 'data_science_python',
    title: 'Data Science with Python',
    topic: 'Data Science',
    category: 'data-science',
    icon: '📊',
    description: 'Master data analysis, visualization, and machine learning with Python',
    duration_weeks: 14,
    confidence: 0.93,
    why_this_fits: 'Industry-standard tools and techniques for data science careers',
    weeks: [
      {
        week: 1,
        theme: 'Python Fundamentals',
        tasks: [{
          id: '1',
          title: 'Python Basics',
          description: 'Syntax, data types, control flow',
          est_hours: 12,
          deliverable: '50 Python exercises',
          resources: [
            { title: 'Python Tutorial', url: 'https://www.youtube.com/watch?v=rfscVS0vtbw', type: 'video', platform: 'YouTube', is_free: true, duration: '4h' }
          ]
        }]
      },
      {
        week: 2,
        theme: 'NumPy & Arrays',
        tasks: [{
          id: '2',
          title: 'NumPy Mastery',
          description: 'Array operations and linear algebra',
          est_hours: 10,
          deliverable: 'Matrix calculations',
          resources: [
            { title: 'NumPy Tutorial', url: 'https://www.youtube.com/watch?v=QUT1VHiLmmI', type: 'video', platform: 'YouTube', is_free: true, duration: '1h' }
          ]
        }]
      },
      {
        week: 3,
        theme: 'Pandas DataFrames',
        tasks: [{
          id: '3',
          title: 'Data Manipulation',
          description: 'Cleaning, filtering, grouping data',
          est_hours: 15,
          deliverable: 'Clean real dataset',
          resources: [
            { title: 'Pandas Course', url: 'https://www.youtube.com/watch?v=vmEHCJofslg', type: 'video', platform: 'YouTube', is_free: true, duration: '1h' }
          ]
        }]
      },
      {
        week: 4,
        theme: 'Data Visualization',
        tasks: [{
          id: '4',
          title: 'Matplotlib & Seaborn',
          description: 'Create compelling visualizations',
          est_hours: 12,
          deliverable: 'Dashboard with 10 charts',
          resources: [
            { title: 'Matplotlib Tutorial', url: 'https://www.youtube.com/watch?v=3Xc3CA655Y4', type: 'video', platform: 'YouTube', is_free: true, duration: '1h' }
          ]
        }]
      },
      {
        week: 5,
        theme: 'SQL for Data Science',
        tasks: [{
          id: '5',
          title: 'Database Queries',
          description: 'SELECT, JOIN, aggregations',
          est_hours: 10,
          deliverable: '30 SQL queries',
          resources: [
            { title: 'SQL Tutorial', url: 'https://www.youtube.com/watch?v=HXV3zeQKqGY', type: 'video', platform: 'YouTube', is_free: true, duration: '4h' }
          ]
        }]
      },
      {
        week: 6,
        theme: 'Statistics Fundamentals',
        tasks: [{
          id: '6',
          title: 'Descriptive Statistics',
          description: 'Mean, median, variance, distributions',
          est_hours: 12,
          deliverable: 'Statistical analysis report',
          resources: [
            { title: 'Statistics Course', url: 'https://www.youtube.com/watch?v=xxpc-HPKN28', type: 'video', platform: 'YouTube', is_free: true, duration: '8h' }
          ]
        }]
      },
      {
        week: 7,
        theme: 'Probability & Hypothesis Testing',
        tasks: [{
          id: '7',
          title: 'Statistical Inference',
          description: 'P-values, confidence intervals, A/B testing',
          est_hours: 15,
          deliverable: 'A/B test analysis',
          resources: [
            { title: 'Hypothesis Testing', url: 'https://www.youtube.com/watch?v=0oc49DyA3hU', type: 'video', platform: 'YouTube', is_free: true, duration: '30m' }
          ]
        }]
      },
      {
        week: 8,
        theme: 'Machine Learning Basics',
        tasks: [{
          id: '8',
          title: 'Scikit-learn Introduction',
          description: 'Train/test split, model evaluation',
          est_hours: 12,
          deliverable: 'First ML model',
          resources: [
            { title: 'ML Course', url: 'https://www.youtube.com/watch?v=7eh4d6sabA0', type: 'video', platform: 'YouTube', is_free: true, duration: '12h' }
          ]
        }]
      },
      {
        week: 9,
        theme: 'Supervised Learning',
        tasks: [{
          id: '9',
          title: 'Classification & Regression',
          description: 'Linear regression, logistic regression, decision trees',
          est_hours: 15,
          deliverable: 'Prediction model',
          resources: [
            { title: 'Supervised Learning', url: 'https://www.youtube.com/watch?v=aircAruvnKk', type: 'video', platform: 'YouTube', is_free: true, duration: '20m' }
          ]
        }]
      },
      {
        week: 10,
        theme: 'Unsupervised Learning',
        tasks: [{
          id: '10',
          title: 'Clustering & Dimensionality Reduction',
          description: 'K-means, PCA, t-SNE',
          est_hours: 12,
          deliverable: 'Customer segmentation',
          resources: [
            { title: 'Clustering Tutorial', url: 'https://www.youtube.com/watch?v=IUn8k5zSI6g', type: 'video', platform: 'YouTube', is_free: true, duration: '15m' }
          ]
        }]
      },
      {
        week: 11,
        theme: 'Feature Engineering',
        tasks: [{
          id: '11',
          title: 'Feature Selection & Creation',
          description: 'Improve model performance',
          est_hours: 10,
          deliverable: 'Optimized features',
          resources: [
            { title: 'Feature Engineering', url: 'https://www.youtube.com/watch?v=6WDFfaYtN6s', type: 'video', platform: 'YouTube', is_free: true, duration: '1h' }
          ]
        }]
      },
      {
        week: 12,
        theme: 'Model Evaluation & Tuning',
        tasks: [{
          id: '12',
          title: 'Hyperparameter Optimization',
          description: 'Grid search, cross-validation',
          est_hours: 12,
          deliverable: 'Tuned model',
          resources: [
            { title: 'Model Tuning', url: 'https://www.youtube.com/watch?v=5nYqK-HaoKY', type: 'video', platform: 'YouTube', is_free: true, duration: '30m' }
          ]
        }]
      },
      {
        week: 13,
        theme: 'Deep Learning Intro',
        tasks: [{
          id: '13',
          title: 'Neural Networks with TensorFlow',
          description: 'Build your first neural network',
          est_hours: 15,
          deliverable: 'Image classifier',
          resources: [
            { title: 'TensorFlow Tutorial', url: 'https://www.youtube.com/watch?v=tPYj3fFJGjk', type: 'video', platform: 'YouTube', is_free: true, duration: '7h' }
          ]
        }]
      },
      {
        week: 14,
        theme: 'Capstone Project',
        tasks: [{
          id: '14',
          title: 'End-to-End Data Science Project',
          description: 'Complete analysis and model deployment',
          est_hours: 20,
          deliverable: 'Portfolio project',
          resources: [
            { title: 'Kaggle Datasets', url: 'https://www.kaggle.com/datasets', type: 'doc', platform: 'Kaggle', is_free: true }
          ]
        }]
      }
    ]
  }
]
